import { get, includes } from 'lodash';

import { PayloadApiRequest } from '../actions/sagaApi';
import axiosClient from '../utils/axiosClient';

import createResource from './createResource';
import fileUploadsResource from './fileUploadsResource';
import settingsResource from './settingsResource';
import { EntityID, UserBase } from './types';

const usersResource = createResource<UserBase>({
  key: 'users',
  url: '/users',
  // TODO: back-end > Support bulk for users: `/users/crudList?_id=:id1,:id2,:id2`
  hasFetchBulkSupport: false,
  // NOTE: use `lookups` instead of `schemaDefinition`?
  // lookups: {
  //   settings: settingsResource,
  // },
  schemaDefinition: {
    settings: settingsResource.settingsSchema,
    avatar: fileUploadsResource.schema,
  },
  processStrategy: (data) => ({
    ...data,
    // extended
    $isWidgetUser: includes(get(data, 'roles'), 'widget'),
  }),
});

const customActions = {
  uploadFile: (
    id: EntityID,
    payload: PayloadApiRequest<UserBase> & {
      data: { name: string; extension: string; fileBase64: string };
    },
  ) =>
    usersResource.request({
      method: 'put',
      url: `${usersResource.url}/${id}/upload`,
      ...payload,
    }),
};

export default {
  ...usersResource,
  ...customActions,
  // TODO: remove
  fetchUser: ({ id }: { id: string }) =>
    axiosClient.get(`${usersResource.url}/${id}`, {
      // @ts-ignore
      schema: usersResource.schema,
    }).catch((err: any) => {
      // return undefined to sagaFetchCurrentUser in case of error to retrieve the user
    }),
};
